import React from 'react'
import CookieNotice from 'react-cookienotice';

const Cookies = () => <CookieNotice />

export default Cookies;